module.exports = __webpack_public_path__ + "media/src/img/arrow-down-39d431c7d3b07dcf7893f5cbe4ce0b9a.svg";